var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75505 5.41652C8.09805 5.41652 7.08103 4.66952 6.01003 4.69652C4.59703 4.71452 3.30103 5.51551 2.57203 6.78451C1.10503 9.33153 2.19403 13.0935 3.62503 15.1635C4.32703 16.1715 5.15503 17.3055 6.25303 17.2695C7.30603 17.2245 7.70205 16.5855 8.98005 16.5855C10.249 16.5855 10.609 17.2695 11.725 17.2425C12.859 17.2245 13.579 16.2165 14.272 15.1995C15.073 14.0295 15.406 12.8955 15.424 12.8325C15.397 12.8235 13.219 11.9865 13.192 9.46653C13.174 7.36051 14.911 6.35252 14.992 6.30752C14.002 4.85851 12.481 4.69652 11.95 4.66052C10.564 4.55252 9.40305 5.41652 8.75505 5.41652ZM11.095 3.29252C11.68 2.59052 12.067 1.60952 11.959 0.637512C11.122 0.673512 10.114 1.19552 9.51105 1.89752C8.97105 2.51852 8.50305 3.51752 8.62905 4.47152C9.55605 4.54351 10.51 3.99451 11.095 3.29252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleSmall);
export default __webpack_public_path__ + "static/media/apple_small.433c2951ed1b026cb551a5a2360c03d8.svg";
export { ForwardRef as ReactComponent };